"use client";
import { MouseEvent } from "react";
import { playVideo } from "./play-video";

export const onVideoMouseEnter = (e: MouseEvent<HTMLVideoElement>) => {
  const target = e.currentTarget;
  playVideo(target);
};

export const onTouchStart = (e: MouseEvent<HTMLVideoElement>) => {
  const target = e.currentTarget;
  target.muted = true;
  playVideo(target);
};
